import { render, staticRenderFns } from "./IconViewGridAddSolid.vue?vue&type=template&id=372c734e"
import script from "./IconViewGridAddSolid.vue?vue&type=script&lang=js"
export * from "./IconViewGridAddSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports